import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { environment } from '../../environments/environment';

type DocItem = { name: string; url: string };

@Injectable({ providedIn: 'root' })
export class ZipDownloadService {
  // If your doc URLs are relative like "/media/..."
  // set your backend base URL here
  private readonly BASE_URL = environment.APIUrl;

  constructor(private http: HttpClient) {}

  async downloadDocsAsZip(documents: DocItem[], zipName = 'documents.zip') {
    if (!documents?.length) return;

    const zip = new JSZip();

    // Download all files in parallel
    const tasks = documents.map(async (doc) => {
      const fileUrl = this.toAbsoluteUrl(doc.url);

      // Fetch as blob
      const blob = await this.http
        .get(fileUrl, { responseType: 'blob' })
        .toPromise();

      // Add to zip
      zip.file(doc.name, blob as Blob);
    });

    // Wait for all downloads
    await Promise.all(tasks);

    // Generate zip blob
    const zipBlob = await zip.generateAsync({ type: 'blob' });

    // Download
    saveAs(zipBlob, zipName);
  }

  private toAbsoluteUrl(url: string) {
    if (!url) return url;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return `${this.BASE_URL}${url}`;
  }
}
